import { ACData } from '../interfaces';
import { Card, Divider, H3, InputGroup } from '@blueprintjs/core';

interface BuildCardProps {
  acData: ACData
  edit?: boolean
  setACData?: (acData: ACData | ((acData: ACData) => ACData)) => void
  onClick?: () => void
  interactive?: boolean
}

function BuildCard({ acData, edit, setACData, onClick, interactive }: BuildCardProps) {
  const platforms: { [key: number]: any } = {
    0: { name: "Choose Platform", icon: "" },
    1: { name: "Playstation", icon: `${process.env.REACT_APP_API_BASE_URL}/playstation512.png` },
    2: { name: "Xbox", icon: `${process.env.REACT_APP_API_BASE_URL}/xbox512.png` },
    3: { name: "PC", icon: `${process.env.REACT_APP_API_BASE_URL}/steam512.png` }
  }

  const platform = acData.platform ? acData.platform : 0;

  return (
    <Card interactive={interactive} onClick={onClick}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {acData.user &&
          <span>{acData.user.username}</span>}
      </div>
      {edit ?
        <InputGroup
          placeholder="AC DATA 001"
          value={acData.name}
          onChange={e => { if (setACData) { setACData((acData => { return { ...acData, ...{ name: e.target.value } } })) } }}
          large /> :
        <H3>{acData.name}</H3>
      }
      {edit ?
        <div style={{ display: "flex" }}>
          {/* <Select
            items={platforms}
            itemRenderer={(item, {handleClick, handleFocus}) => <Button key={item.value} onClick={handleClick} onFocus={handleFocus} ><link href={item.icon} />{item.name}</Button>}
            onItemSelect={item => { if (setACData) { setACData((acData => { return { ...acData, ...{ platform: item.value } } })) } }}
            filterable={false}
          >
            <Button text={acData.platform ? platforms.filter(e => e.value === acData.platform)[0].name : ""} rightIcon="caret-down" placeholder="Select a platform" />
          </Select> */}
          <select value={acData.platform!} onChange={e => { if (setACData) { setACData((acData => { return { ...acData, ...{ platform: parseInt(e.target.value) } } })) } }}>
            {Object.entries(platforms).map(([k, v]) => <option key={k} value={k}>
              {/* <link rel="icon" href={e.icon} /> */}
              {v.name}
            </option>)}
          </select>
          <InputGroup
            placeholder="Share Key"
            value={acData.shareKey ? acData.shareKey : ""}
            onValueChange={(value) => {
              if (setACData) {
                setACData((acData => { return { ...acData, ...{ shareKey: value } } }))
              }
            }}
            fill />
        </div>
        :
        <div style={{ display: "flex", alignContent: "center" }}>
          {platform !== 0 ?
            <>
              <img src={platforms[platform].icon} alt={platforms[platform].name} style={{ height: "18px" }} />
              <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>{platforms[platform].name}</span>
            </> : <></>
          }
          {acData.shareKey ? <span style={{ display: "inline-flex", alignItems: "center", marginLeft: "5px" }}>{acData.shareKey}</span> : <></>}
        </div>
      }
      <table style={{ paddingRight: "10px" }}>
        <tbody style={{ marginBottom: "15px" }}>
          <tr><td><b>R-Arm Unit</b></td><td>{acData.frame.rArmUnit?.id !== 0 ? acData.frame.rArmUnit?.name : "None"}</td></tr>
          <tr><td><b>L-Arm Unit</b></td><td>{acData.frame.lArmUnit?.id !== 0 ? acData.frame.lArmUnit?.name : "None"}</td></tr>
          <tr><td><b>R-Back Unit</b></td><td>{acData.frame.rBackUnit?.id !== 0 ? acData.frame.rBackUnit?.name : "None"}</td></tr>
          <tr><td><b>L-Back Unit</b></td><td>{acData.frame.lBackUnit?.id !== 0 ? acData.frame.lBackUnit?.name : "None"}</td></tr>
        </tbody>
        <tbody>
          <tr><td><b>Head</b></td><td>{acData.frame.head?.name}</td></tr>
          <tr><td><b>Core</b></td><td>{acData.frame.core?.name}</td></tr>
          <tr><td><b>Arms</b></td><td>{acData.frame.arms?.name}</td></tr>
          <tr><td><b>Legs</b></td><td>{acData.frame.legs?.name}</td></tr>
        </tbody>
        <tbody>
          <tr><td><b>Booster</b></td><td>{acData.frame.booster?.id !== 0 ? acData.frame.booster?.name : "None"}</td></tr>
          <tr><td><b>FCS</b></td><td>{acData.frame.fcs?.name}</td></tr>
          <tr><td><b>Generator</b></td><td>{acData.frame.generator?.name}</td></tr>
        </tbody>
        <tbody>
          <tr><td><b>Expansion</b></td><td>{acData.frame.expansion?.id !== 0 ? acData.frame.expansion?.name : "None"}</td></tr>
        </tbody>
      </table>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {acData.lastUpdate &&
          <span style={{color: "#5F6B7C"}}>{acData.lastUpdate}</span>
        }
      </div>
    </Card>
  );
}

export default BuildCard;